import Tile from './Tile'

interface LayoutProps {
  activeLayout: Array<string[]>
}

export default function Layout({ activeLayout }: LayoutProps) {
  const flattenedLayout = activeLayout.flat()
  return (
    <div className="grid grid-cols-5 gap-0.5">
      {flattenedLayout.map((ticker, index) => (
        <Tile key={`tile-${index}-${ticker}`} ticker={ticker} hoverOffsetX={0} hoverOffsetY={25} />
      ))}
    </div>
  )
}
